<template>
  <svg id="icon-users" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-141.5-12.5h554v512h-554z"/>
      <g fill="currentColor" fill-rule="nonzero">
        <path d="M14.708 7.81a1.77 1.77 0 1 1 3.541 0 1.77 1.77 0 0 1-3.54 0zm4.25 4.21c0 .21-4.958.21-4.958 0v-.765c0-1.055 2.122-1.91 2.479-1.91.377 0 2.478.855 2.478 1.91v.764zM1.708 7.81a1.77 1.77 0 1 1 3.541 0 1.77 1.77 0 0 1-3.54 0zm4.25 4.21c0 .21-4.958.21-4.958 0v-.765c0-1.055 2.122-1.91 2.479-1.91.377 0 2.478.855 2.478 1.91v.764zM6.071 7.179a3.929 3.929 0 1 1 7.858 0 3.929 3.929 0 0 1-7.858 0zm9.429 9.339c0 .468-11 .468-11 0v-1.696c0-2.34 4.708-4.239 5.5-4.239.837 0 5.5 1.898 5.5 4.24v1.695z"/>
      </g>
    </g>
  </svg>
</template>
